export default __webpack_public_path__ + "static/media/accelerate.6eb6002f.svg";